export const DATA_HOOKS = {
  root: 'membership questions modal',
  questionAnswerRoot: 'membership question root',
  submitButton: 'membership questions submit button',
};
